/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Postfachplz1Inputs */

const de__field_postfachplz1 = /** @type {(inputs: _Field_Postfachplz1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postfach PLZ`)
};

/**

* @param {_Field_Postfachplz1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_postfachplz1 = /** @type {((inputs?: _Field_Postfachplz1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Postfachplz1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_postfachplz1(inputs)
});
export { _field_postfachplz1 as "_field_postfachPlz" }